<header class="bg-primary text-white shadow-lg fixed w-full top-0 z-50">
  <nav class="container mx-auto flex items-center justify-between py-3 px-6">
    <!-- Logo Bereich -->
    <div class="flex items-center">
      <img
        src="assets/logos/white.png"
        alt="Logo"
        class="w-[200px] ml-3 z-40 flex-shrink-0 cursor-pointer"
        [routerLink]="['/home']"
      />
    </div>

    <!-- Mobile Menu Button -->
    <div>
      <button
        class="text-white focus:outline-none mr-4 p-2 rounded hover:bg-primary transition-colors"
        (click)="toggleMenu()"
        aria-label="Menü öffnen/schließen"
      >
        <svg
          class="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            *ngIf="!isMenuOpen"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M4 6h16M4 12h16M4 18h16"
          ></path>
          <path
            *ngIf="isMenuOpen"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M6 18L18 6M6 6l12 12"
          ></path>
        </svg>
      </button>
    </div>
  </nav>

  <!-- Mobile Menu -->
  <div
    class="mobile-menu md:hidden bg-primary overflow-hidden transition-all duration-300 ease-in-out"
    [class.max-h-0]="!isMenuOpen"
    [class.max-h-600]="isMenuOpen"
  >
    <div class="mt-[50px] flex-1 overflow-y-auto ml-1" (click)="toggleMenu()">
      <app-sidebar-item
        icon="home"
        label="Home"
        [routerLink]="['/home']"
        [routerLinkActive]="['active']"
      ></app-sidebar-item>
      <app-sidebar-item
        icon="garage"
        label="Taxizentralen"
        [routerLink]="['/taxiCenter']"
        [routerLinkActive]="['active']"
      ></app-sidebar-item>
      <app-sidebar-item
        icon="bus"
        label="Busse"
        [routerLink]="['/bus']"
        [routerLinkActive]="['active']"
      ></app-sidebar-item>
      <app-sidebar-item
        icon="worker"
        label="Taxifahrer"
        [routerLink]="['/taxiDriver']"
        [routerLinkActive]="['active']"
      ></app-sidebar-item>
      <app-sidebar-item
        icon="group"
        label="Fahrgäste"
        [routerLink]="['/passenger']"
        [routerLinkActive]="['active']"
      ></app-sidebar-item>
      <app-sidebar-item
        icon="phone"
        label="Fahrgast Accounts"
        [routerLink]="['/appAccounts']"
        [routerLinkActive]="['active']"
      ></app-sidebar-item>
      <app-sidebar-item
        icon="route"
        label="Transportaufträge"
        [routerLinkActive]="['active']"
        [routerLink]="['/trip']"
      ></app-sidebar-item>
      <app-sidebar-item
        icon="taxitriptour"
        label="Fahrten"
        [routerLinkActive]="['active']"
        [routerLink]="['/triptour']"
      ></app-sidebar-item>
      <app-sidebar-item
        icon="contacts"
        label="Adressbuch"
        [routerLinkActive]="['active']"
        [routerLink]="['/contacts']"
      ></app-sidebar-item>
      <app-sidebar-item
        icon="map"
        label="Live Karte"
        [routerLink]="['/live-map']"
        [routerLinkActive]="['active']"
      ></app-sidebar-item>
    </div>
  </div>
</header>
